import React from 'react';
import { Link } from 'react-router-dom';
import styles from './ClassShowcase.module.css';
import useScrollAnimation from '../../hooks/useScrollAnimation';

const RACES = [
  {
    name: 'Human',
    desc: 'The most versatile race in Aden. Balanced stats allow Humans to fill any role, from frontline warriors to powerful mages.',
    paths: ['Warrior', 'Rogue / Archer', 'Wizard', 'Healer'],
    color: '#C8A75B',
    note: null,
  },
  {
    name: 'Elf',
    desc: 'Graceful children of the forest, built for speed and precision. Elves excel at archery, sword song, and nature magic.',
    paths: ['Knight', 'Rogue / Archer', 'Wizard', 'Healer'],
    color: '#4A8C5C',
    note: null,
  },
  {
    name: 'Dark Elf',
    desc: 'Outcasts who embraced forbidden power. Masters of devastation, shadow magic, and summoned servants of darkness.',
    paths: ['Warrior', 'Rogue / Assassin', 'Wizard', 'Support'],
    color: '#7B5EA7',
    note: null,
  },
  {
    name: 'Orc',
    desc: 'Born for battle. Unmatched HP and raw strength. Their shamans raise entire clans through the power of war cries.',
    paths: ['Warrior', 'Shaman'],
    color: '#8B3A2D',
    note: null,
  },
  {
    name: 'Dwarf',
    desc: 'Masters of craft and commerce. Dwarves forge the finest weapons in Aden and accumulate wealth others only dream of.',
    paths: ['Warrior / Scavenger', 'Crafter / Warsmith'],
    color: '#8B6B2D',
    note: null,
  },
  {
    name: 'Kamael',
    desc: 'Born with a single dark wing, Kamaels grow stronger by consuming the souls of the fallen. A race unlike any other.',
    paths: ['Male: Berserker, Doombringer', 'Female: Arbalester, Trickster', 'Shared: Inspector, Judicator'],
    color: '#5B7EC8',
    note: 'Gender-restricted classes',
  },
  {
    name: 'Ertheia',
    desc: 'Female-only beings of pure creation energy. Three paths unlike anything else in Aden in mechanics and lore.',
    paths: ['Sayha Seer', 'Etherial Knight', 'Valiant'],
    color: '#B07EC8',
    note: 'Female only',
  },
  {
    name: 'High Elf',
    desc: 'A noble bloodline from the Essence era. Two exclusive paths: martial discipline or elemental mastery.',
    paths: ['Divine Templar', 'Element Weaver'],
    color: '#7BA7C8',
    note: 'Essence era addition',
  },
];

export default function ClassShowcase() {
  const [ref, visible] = useScrollAnimation();

  return (
    <section ref={ref} className={`${styles.section} ${visible ? 'visible' : ''} reveal`} aria-label="Playable races">
      <h2 className="section-title">Choose Your Race</h2>
      <p className="section-subtitle">Eight races. Dozens of classes. One world to conquer.</p>
      <hr className="gold-divider" />
      <div className={styles.grid}>
        {RACES.map(({ name, desc, paths, color, note }) => (
          <div
            key={name}
            className={styles.card}
            style={{ '--class-color': color }}
          >
            <div className={styles.cardTop} aria-hidden="true">
              <div className={styles.cardGlyph} />
            </div>
            <div className={styles.cardHeader}>
              <h3 className={styles.className}>{name}</h3>
              {note && <span className={styles.note}>{note}</span>}
            </div>
            <p className={styles.classDesc}>{desc}</p>
            <ul className={styles.paths} aria-label={`${name} class paths`}>
              {paths.map(p => <li key={p}>{p}</li>)}
            </ul>
            <div className={styles.cardHoverLine} aria-hidden="true" />
          </div>
        ))}
      </div>
      <div className={styles.cta}>
        <Link to="/races" className={styles.ctaLink}>View Full Class List</Link>
      </div>
    </section>
  );
}
